<template>
    <div class="dm-container-y dm-text prose">
        <iframe
            v-if="complyAuto.enabled"
            :src="`https://consumer.complyauto.com/privacy-policy/${complyAuto.ids.privacyPolicy}`"
            style="height: 1200px; width: 100%"
            title="Privacy Policy"
        />
        <template v-else>
            <Heading tag="h1" :content="t('privacy_policy')" />
            <p>
                This document describes
                {{ organizationName }}'s policy regarding standard information
                collected in normal web site usage as well as information you
                provide when you visit our web site. The amount and type of
                information received depends on how you use our site.
            </p>

            <Heading tag="h3" content="Normal Web Site Usage:" />
            <p>
                During normal web site usage, we do not collect or store
                personally identifiable information such as name, mailing
                address, e-mail address, phone number, or social security
                number. You can visit
                {{ organizationName }}'s web site to read product, company, and
                other information. The only information we collect and store
                during normal web site usage is the name of your Internet
                service provider, the web site you last visited, the pages you
                request, and the date and time of those requests.We collect this
                information to generate statistics and measure site activity to
                improve the usefulness of customer visits. This information is
                shared only within {{ organizationName }}.
            </p>

            <Heading tag="h3" content="Collection of Personal Information:" />
            <p>
                At times, particularly when you use one of our on-line services
                (i.e., new-car buying, used-car buying,
                {{ organizationName }}'s on-line credit application, etc.)
                {{ organizationName }} may ask you to provide certain
                information about yourself by filling out and submitting an
                online form. It is completely optional for you to fill out any
                one of these forms. If you choose to use one of these on-line
                services, however, {{ organizationName }} may require that you
                provide information, which may include your name, mailing
                address, e-mail address, social security number or other
                personally identifying information. When you submit personal
                information to {{ organizationName }}, you understand and agree
                that {{ organizationName }} may access, store, and utilize your
                customer profile information. We may share information about
                your personal information with reputable credit reporting
                agencies as authorized under federal and state laws, but only as
                lawfully permitted or required. We collect this information for
                a variety of reasons, including but not limited to informing you
                of special offers, and other products and services from
                {{ organizationName }}.
            </p>
            While we have not done so at this time, in the future we may
            contract with other reputable companies in our efforts to offer you
            additional attractive products and services. If you do not want the
            information you provide to
            {{ organizationName }} to be shared with other companies, please
            indicate this preference when you provide the information to
            {{ organizationName }} in the comments section. Of course, we will
            honor your request. {{ organizationName }}'s privacy practices are
            designed to provide a high level of protection for your personal
            information and our computer systems.

            <Heading
                tag="h3"
                content="Interest-Based/Online Behavioral Advertising:"
            />
            <p>
                On some pages of our site we may allow third-party advertising
                partners to set web tracking tools (e.g., cookies and web
                beacons) to collect anonymous, non-personally identifiable
                information regarding your activities on those pages (e.g., your
                IP address, page(s) visited, time of day). We may also share
                such information we have collected with third-party advertising
                partners. These advertising partners may use this information
                (and similar information collected from other websites) for
                purposes of delivering future targeted advertisements to you
                when you visit other sites within their networks. This practice
                is commonly referred to as "interest-based advertising" or
                "online behavioral advertising." A "cookie" is a small text file
                or text identifier placed on your computer to assist us in
                providing customized services. We use cookies to provide you
                with a convenience feature to save you time and provide a more
                personalized experience on our site. For example, you may log on
                once during a visit and will be able to access multiple servers
                without having to log on again and again. We also use the
                information for internal research on our user's demographics,
                interests, and behavior to better understand our visitor's
                preferences. We may use cookies provided by Google . You have
                the ability to accept or decline cookies.
            </p>

            <Heading tag="h2" content="CCPA" />
            <Heading tag="h3" content="INFORMATION COLLECTED" />

            <p>
                We collect the following categories of information from and
                about you:
            </p>
            <ul>
                <li>
                    Contact information, such as name, postal address, email
                    address, and phone number.
                </li>
                <li>
                    Information regarding your lease or finance terms and
                    monthly payment amounts, that we may obtain from third-party
                    sources.
                </li>
                <li>
                    Information regarding the mileage on your vehicle, which is
                    collected when you bring your vehicle to our dealership’s
                    service department, or that we may obtain from third-party
                    sources.
                </li>
                <li>Geolocation information.</li>
                <li>Online identifiers, such as username and IP address.</li>
                <li>
                    Usage information, such as how you and your device interact
                    with our website (e.g., the pages you visit or the search
                    terms you enter).
                </li>
                <li>
                    Other information, such as your car preferences, or
                    information regarding your potential trade-in vehicle, that
                    you provide or that we may obtain from third-party sources.
                </li>
            </ul>

            <Heading tag="h3" content="COOKIES" />

            <p>
                We, and third parties we allow, use cookies and other similar
                technologies. Cookies are small text files placed on your device
                that uniquely identify your device and which a website can
                transfer to a consumer’s hard drive to keep records of his or
                her visit to a website. We, or third parties, may use session
                cookies or persistent cookies. Session cookies only last for the
                specific duration of your visit and are deleted when you close
                your browser. Persistent cookies remain on your device’s hard
                drive until you delete them or they expire. Different cookies
                are used to perform different functions, which are explained
                below:
            </p>
            <ul>
                <li>
                    Essential. Some cookies are essential in order to enable you
                    to move around our website and use its features, such as
                    accessing secure areas of our website. Without these
                    cookies, we cannot enable appropriate content based on the
                    type of device you are using.
                </li>
                <li>
                    Analytics. We use Google Analytics to measure how you
                    interact with our website and to improve your user
                    experience. To learn more about Google Analytics privacy
                    practices and opt-out mechanisms, please visit the Google
                    Analytics Security and Privacy Principles page at
                    <a
                        href="https://support.google.com/analytics/answer/6004245?hl=en"
                        target="_blank"
                        >https://support.google.com/analytics/answer/6004245?hl=en</a
                    >. Google also provides a complete privacy policy and
                    instructions on opting-out of Google Analytics at
                    <a
                        href="https://tools.google.com/dlpage/gaoptout"
                        target="_blank"
                        >https://tools.google.com/dlpage/gaoptout</a
                    >.
                </li>
                <li>
                    Targeted Advertising. We use cookies to compile information
                    on our users interaction with our website. We use this
                    information to serve ads to you off of our website.
                </li>
                <li>
                    There are several ways to manage cookies. You can control
                    the use of cookies at the browser level, by instructing your
                    browser to accept cookies, disable cookies or notify you
                    when receiving a new cookie. Please note that if you reject
                    cookies, you may still use our website, but your ability to
                    use some features or areas of our website may be limited.
                    The Network Advertising Initiative also offers a means to
                    opt-out of a number of advertising cookies. Please visit
                    www.networkadvertising.org to learn more. Note that
                    opting-out does not mean you will no longer receive online
                    advertising. It does mean that the company or companies from
                    which you opted-out will no longer deliver ads tailored to
                    your preferences and usage patterns.
                </li>
            </ul>

            <Heading tag="h3" content="USE OF INFORMATION COLLECTED" />
            <p>
                We use the information we collect from you for the following
                purposes:
            </p>
            <ul>
                <li>To provide our Services.</li>
                <li>To send you marketing communications.</li>
                <li>To respond to your requests and inquiries.</li>
                <li>
                    To improve user experiences by making our website easier to
                    use and navigate.
                </li>
                <li>For other legitimate business purposes.</li>
            </ul>

            <Heading tag="h3" content="SHARING AND DISCLOSURE OF INFORMATION" />
            <p>
                We may share or disclose your information to the following
                categories of third parties and for the following reasons:
            </p>
            <ul>
                <li>
                    To third-party service providers, agents or independent
                    contractors who help us maintain our Services and provide
                    other administrative services to us.
                </li>
                <li>
                    To unaffiliated third parties whose products and/or services
                    we believe might be of interest to you.
                </li>
                <li>
                    We may share your personal information in the course of any
                    reorganization process including, but not limited to,
                    mergers, acquisitions, and sales of all or substantially all
                    of our assets.
                </li>
                <li>
                    We may disclose your personal information to law
                    enforcement, government agencies, and other related third
                    parties, in order to comply with the law, enforce our
                    policies, or protect our or others’ rights, property or
                    safety.
                </li>
            </ul>
            <p>
                If you would like to see your personal information collected,
                delete your personal information from our records, opt out of
                the sale of your personal information or have any questions
                concerning your personal information please fill out the form on
                our CCPA page and one of our representatives will reach out to
                you.
            </p>
            <p>
                We reserve the right to change our Privacy Policy. A revised
                Privacy Policy will only apply to data collected subsequent to
                its effective date. Any revisions will be posted at least 10
                days prior to its effective date.
            </p>
        </template>
    </div>
</template>

<script setup lang="ts">
import Heading from '~/components/Layout/Heading.vue'
const { t } = useI18n()

const domainStore = useDomainStore()

const organizationName = computed(() => domainStore.autoZnetworkEntity.name)
const complyAuto = computed(() => domainStore.complyAuto)
</script>
